"use client";

import { useEffect, useState } from "react";

// The viewer's Unlimited Instant Graphics subscription (lib/subscription.js):
// { loaded, signedIn, subscribed, status, nextBillingDate, endsAt }.
// Pages use it to show "Included" and the watermark-free downloads; the
// routes behind those downloads check again server-side.
export default function useSubscription() {
  const [sub, setSub] = useState({ loaded: false, signedIn: false, subscribed: false, status: "none" });
  useEffect(() => {
    let cancelled = false;
    fetch("/api/subscription", { cache: "no-store", credentials: "include" })
      .then((r) => r.json()).then((d) => { if (!cancelled) setSub({ ...d, loaded: true }); })
      .catch(() => { if (!cancelled) setSub((s) => ({ ...s, loaded: true })); });
    return () => { cancelled = true; };
  }, []);
  return sub;
}
